// Verbatim from apps/mobile-user/src/core/theme/tokens.ts — JS-side exact-hex source, see tokens.css.

export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  32: 128,
} as const;

export const radii = {
  none: 0,
  sm: 4,
  base: 8,
  md: 12,
  lg: 16,
  xl: 24,
  full: 9999,
} as const;

export const fontSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  "2xl": 24,
  "3xl": 30,
  "4xl": 36,
  "5xl": 48,
} as const;

export const fontWeights = {
  regular: "400",
  medium: "500",
  semibold: "600",
  bold: "700",
} as const;

export const brandColors = {
  primary: {
    50: "#fdecea",
    100: "#f9c6c6",
    200: "#f29b9b",
    300: "#ea6f6f",
    400: "#e14d4d",
    500: "#d32f2f",
    600: "#c62828",
    700: "#b71c1c",
    800: "#8e1616",
    900: "#5c0e0e",
  },
  gray: {
    50: "#f7f7f8",
    100: "#eeeeef",
    200: "#dddfe1",
    300: "#c3c6ca",
    400: "#9a9ea3",
    500: "#6c7075",
    600: "#54585d",
    700: "#3d4045",
    800: "#26282b",
    900: "#18191b",
  },
  backgroundColor: {
    main: "#f8f8f9",
    secondary: "#f1f1f2",
    subtle: "#f4f4f5",
  },
  border: {
    300: "#e2e3e5",
    400: "#d1d3d5",
    500: "#bcbec1",
  },
  success: {
    50: "#e9f8ef",
    500: "#23b85c",
    600: "#20a754",
    700: "#198341",
  },
  error: {
    50: "#feedeb",
    500: "#f2463a",
    600: "#dc4035",
    700: "#ac3229",
  },
  warning: {
    50: "#fff4ef",
    500: "#ff9162",
    600: "#e88459",
    700: "#b56746",
  },
  info: {
    50: "#eff9fc",
    500: "#5fc4de",
    600: "#56b2ea",
    700: "#438b9e",
  },
} as const;
